module.exports = __webpack_public_path__ + "static/media/AbdulWasiu Popoola.524ec77e.jpeg";